export const SearchIcon = ({ size = '22', color = '#848C98' }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4_32)">
      <path
        d="M19.2686 18.5949L16.1519 15.4874C17.1575 14.2063 17.7031 12.6243 17.7011 10.9957C17.7011 9.54529 17.271 8.12747 16.4652 6.92151C15.6594 5.71555 14.5141 4.77562 13.1741 4.22057C11.8341 3.66553 10.3596 3.52031 8.9371 3.80326C7.51457 4.08622 6.2079 4.78466 5.18231 5.81024C4.15673 6.83583 3.45829 8.1425 3.17534 9.56503C2.89238 10.9876 3.0376 12.462 3.59264 13.802C4.14769 15.142 5.08762 16.2873 6.29358 17.0931C7.49954 17.8989 8.91737 18.329 10.3678 18.329C11.9964 18.331 13.5783 17.7854 14.8594 16.7799L17.9669 19.8965C18.0521 19.9824 18.1535 20.0506 18.2652 20.0972C18.3769 20.1437 18.4968 20.1677 18.6178 20.1677C18.7388 20.1677 18.8586 20.1437 18.9703 20.0972C19.082 20.0506 19.1834 19.9824 19.2686 19.8965C19.3545 19.8113 19.4227 19.7099 19.4692 19.5982C19.5158 19.4865 19.5397 19.3667 19.5397 19.2457C19.5397 19.1247 19.5158 19.0049 19.4692 18.8932C19.4227 18.7815 19.3545 18.6801 19.2686 18.5949ZM4.86776 10.9957C4.86776 9.90789 5.19033 8.84452 5.79468 7.94005C6.39903 7.03558 7.25801 6.33063 8.263 5.91435C9.268 5.49807 10.3739 5.38915 11.4408 5.60137C12.5077 5.81359 13.4877 6.33741 14.2568 7.1066C15.026 7.87579 15.5499 8.8558 15.7621 9.92269C15.9743 10.9896 15.8654 12.0955 15.4491 13.1005C15.0328 14.1054 14.3279 14.9644 13.4234 15.5688C12.5189 16.1731 11.4556 16.4957 10.3678 16.4957C8.90907 16.4957 7.51012 15.9162 6.47867 14.8848C5.44722 13.8533 4.86776 12.4544 4.86776 10.9957Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_4_32">
        <rect
          width={size}
          height={size}
          fill="white"
          transform="translate(0.284424 0.912354)"
        />
      </clipPath>
    </defs>
  </svg>
);
